'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POIMapComponent = exports.defaultStyles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral([''], ['']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _leaflet = require('leaflet');

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

var _bduiCoremap = require('@bd/bdui-coremap');

var _bduiCoremap2 = _interopRequireDefault(_bduiCoremap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function uppercaseWords(str) {
  return str.toString().replace('_', ' ').replace(/^(.)|\s+(.)/g, function ($1) {
    return $1.toUpperCase();
  });
}

var getMarkerBounds = function getMarkerBounds(markers) {
  var boundarySize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var boundaryPadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;

  var bounds = (markers || []).filter(function (marker) {
    return marker.geoIndexed;
  }).reduce(function (boundsResult, marker) {
    var coords = void 0;
    try {
      coords = new _leaflet.LatLng(marker.geoIndexed[1], marker.geoIndexed[0]);
    } catch (e) {
      return boundsResult;
    }

    if (!boundsResult) {
      // TODO : Check if coordinates are valid before adding to bounds
      return coords.toBounds(boundarySize);
    }
    if (boundsResult && marker.geoIndexed) {
      // TODO : Check if coordinates are valid before adding to bounds
      boundsResult.extend([parseFloat(marker.geoIndexed[1]), parseFloat(marker.geoIndexed[0])]);
    }
    return boundsResult;
  }, undefined);

  return bounds && bounds.isValid() ? bounds.pad(boundaryPadding / 100) : undefined;
};

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

var POIMapComponent = exports.POIMapComponent = function (_React$Component) {
  _inherits(POIMapComponent, _React$Component);

  function POIMapComponent(props) {
    _classCallCheck(this, POIMapComponent);

    var _this = _possibleConstructorReturn(this, (POIMapComponent.__proto__ || Object.getPrototypeOf(POIMapComponent)).call(this, props));

    _this.setCategory = function (e, category) {
      e.preventDefault();
      _this.setState({
        selectedCategory: _this.state.selectedCategory === category ? null : category
      });
    };

    _this.setActivePin = function (_id) {
      return function () {
        return _this.setState({ activePin: _id });
      };
    };

    _this.loadPOIs = function () {
      var community = _this.props.community;

      var markers = _lodash2.default.get(community, 'poimap.customPoints', []).map(function (marker) {
        return _extends({}, marker, {
          icon: new _leaflet.Icon({
            iconUrl: marker.pin
          })
        });
      });

      _this.setState({
        markers: markers
      });
    };

    _this.state = {
      markers: [],
      activePin: undefined
    };
    return _this;
  }

  _createClass(POIMapComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadPOIs();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var community = _ref.community;
      var prevCommunity = this.props.community;

      if (prevCommunity._id !== community._id) {
        this.loadPOIs();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          community = _props.community,
          key = _props.key,
          popup = _props.popup,
          tileUrl = _props.tileUrl;
      var _state = this.state,
          activePin = _state.activePin,
          markers = _state.markers,
          selectedCategory = _state.selectedCategory;


      if (_lodash2.default.get(community, 'poimap.version') !== 2) {
        // eslint-disable-next-line no-console
        console.error('POI Map Exists, but is the incorrect version. Please update the POI Map for ' + community.name);
        return null;
      }

      var categories = _lodash2.default.uniq(_lodash2.default.map(_lodash2.default.get(community, 'poimap.customPoints', []), 'type'));
      var communityMarker = _extends({}, community, {
        icon: new _leaflet.Icon({
          iconUrl: 'https://www.mybuildercloud.com/_images/pins/poi/community.png'
        })
      });

      var bounds = getMarkerBounds(_lodash2.default.get(community, 'poimap.customPoints', []).concat([communityMarker]));

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: 'POIMap_wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'POIMap_inner' },
            _react2.default.createElement(
              'ul',
              { className: 'POIMap_categories' },
              categories.map(function (category) {
                return _react2.default.createElement(
                  'li',
                  { key: category, className: '' + (selectedCategory === category ? 'active' : '') },
                  _react2.default.createElement(
                    'a',
                    { href: true, className: 'clickable', onClick: function onClick(e) {
                        _this2.setCategory(e, category);
                      } },
                    _react2.default.createElement('img', {
                      src: _lodash2.default.get(markers.find(function (marker) {
                        return marker.type === category;
                      }), 'pin'),
                      alt: uppercaseWords(category)
                    }),
                    ' ',
                    uppercaseWords(category)
                  ),
                  selectedCategory === category && _react2.default.createElement(
                    'ul',
                    null,
                    markers.filter(function (marker) {
                      return marker.type === category;
                    }).map(function (marker) {
                      return _react2.default.createElement(
                        'li',
                        { key: marker._id },
                        _react2.default.createElement(
                          'span',
                          { role: 'button', tabIndex: '0', onClick: _this2.setActivePin(marker._id) },
                          marker.name
                        )
                      );
                    })
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'POIMap_mapWrapper' },
            _react2.default.createElement(_bduiCoremap2.default, {
              bounds: bounds,
              activePin: activePin,
              key: key,
              markers: markers.filter(function (marker) {
                return !selectedCategory || marker.type === selectedCategory;
              }).concat([communityMarker]),
              popup: popup,
              tileUrl: tileUrl
            })
          )
        )
      );
    }
  }]);

  return POIMapComponent;
}(_react2.default.Component);

POIMapComponent.propTypes = {
  className: _propTypes2.default.string,
  community: _propTypes2.default.object.isRequired,
  key: _propTypes2.default.string,
  popup: _propTypes2.default.func,
  tileUrl: _propTypes2.default.string
};

POIMapComponent.defaultProps = {
  className: undefined,
  key: undefined,
  // eslint-disable-next-line react/prop-types
  popup: function popup(_ref2) {
    var marker = _ref2.marker;
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'b',
        null,
        marker.name
      ),
      ' ',
      _react2.default.createElement('br', null),
      ' ',
      marker.formatted_address
    );
  },
  tileUrl: undefined
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(POIMapComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-poimap/build/POIMap.js
// module id = 1071
// module chunks = 0